import { formatPhoneNumber } from "@/utils/phone";

interface FormattedPhoneProps {
  value: string | null | undefined;
  className?: string;
}

export const FormattedPhone = ({ value, className }: FormattedPhoneProps) => {
  if (!value) return null;
  return (
    <a href={`tel:${value}`} className={className}>
      {formatPhoneNumber(value)}
    </a>
  );
};